import React, { useState } from 'react';
import { Wrapper } from './styles';
import { setCPF as setCPFRedux } from '../../store/auth/actions';
import { useDispatch } from 'react-redux';

function Widget() {
  //componente provisório para validação de layout. Após a aprovação, será deletado
  const dispatch = useDispatch();

  const [cpf, setCpf] = useState('');

  const submit = () => {
    window.top.location.href = `/contato/widget/${cpf}`;
    dispatch(setCPFRedux(cpf));
  };

  return (
    <Wrapper>
      <img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAA0CAYAAADFeBvrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMNSURBVHgB7ZrtcdpAEIbfEx9x/rkEpYKQDkgDBioIqSDuwFBB6MCkAgUaiFxBSAWQCoJnMhMDQZddWYjj+05Ih8bRM3ODLN8hvdze7t5KQEGBVcSpDlJKF5dnKoSY4lxIjCfzQ1Pnnp0jYlz60PoSSzR0Ojl4YZQN+vpRs0kHacEmt2XDd7DM1vXvdca8OJMrBOWdQtAKDnQyXcZIgXNm6Bo55L8OrNt8pZaKmUQ8IgUSC4qy3wfkjMLL5Z3EJkdutk4fOvmdT+bZhSXOcQoutbpmX2uCCpNTGEFvvzKBRc5x2yxohJxxzgzZgGsaqxTrh86AiwqSHq6fohu+4lJVCxulKrKCAQyxLohFLBx8EALNhUS9FJ1fUJsNMBES/lKi+7qVbO1Z9XK/PdRIzHc67Em56/IFhwKBtuPg25OHWyTAmqCZh2b1WYx7qi8LI1GfacY6MMSKoD8eXOFgs2ojOYNAvVKGy42PSUlf7ULC7viHgAFW1lC5hHsyMXVD2K428WWr209qDyS+WyKTQzST/EPQuvO3HcYhMp+hhYe6ul4kBeNqY0dMDDuDZYCPyqnQiUCT7E1OrGvSJGbyqnE6ryNRPo3zle/QNrvsBTmoxYcy3OXqsVRmUa6/4/TlskZZO1LoxxaxmQNqF2SsxiFhoVKUuSByCHECK4X2/gnSwdv1H/pJsA2nsL4Z8nYckzRHqplCfgRVgnBxxzGEYozH+dyxMfMBelAyCopFfWiSuSAOiIHYcNW1OaVA+2aKz82G8OjwU3xSol+50S+XWckUrm7Qmw8pHkUBlnM1mqnxYghfBs/ejGbBDQOw3Blu9PTb2vahskRrTikQbQ/iIBkKEPHxfgRuKUl9pIDcgQYH31OInoKrpd4JzOoDe8tXcw9tMnQuf7kHxk1JG6+hN3RzccpD57o6okwEmcKC3h/6598BGjxDMopNIny5AqNSgMEqEaWZ6ZuKOiaIL/QLyTkqSBdTUUdfjYmefLeRjBEJaiEFVFGc4FYDvNPdTuQWFkVtbBCY88+pgFxQcAH+AUf77qrpw+7MAAAAAElFTkSuQmCC' />
      <p className='text'>
        Consulte propostas para seus débitos e negocie online!
      </p>
      <input
        type='text'
        id='input'
        className='input'
        placeholder='Digite seu CPF'
        onChange={(e) => setCpf(e.target.value)}
      />
      <button className='button' id='button' onClick={submit}>
        Avançar
      </button>
    </Wrapper>
  );
}

export default Widget;
